import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { backendAuthApiRef } from '@internal/plugin-neo4j-auth-common';

import {
  privateEndpointServiceApiRef,
  PrivateEndpointServiceRestApi,
} from './apis';
import { PRIVATE_ENDPOINTS_BASE_URL } from './const';
import { privateEndpointsRouteRef } from './routes';

const privateEndpointServiceApi = ApiBlueprint.make({
  name: 'private-endpoint-service-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: privateEndpointServiceApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          backendAuthApi: backendAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, backendAuthApi }) =>
          new PrivateEndpointServiceRestApi({
            discoveryApi,
            fetchApi,
            backendAuthApi,
          }),
      }),
    ),
});

const privateEndpointsPage = PageBlueprint.make({
  params: {
    loader: () => import('./components').then(m => <m.PrivateEndpointsPage />),
    noHeader: true,
    path: PRIVATE_ENDPOINTS_BASE_URL,
    routeRef: privateEndpointsRouteRef,
  },
});

export const neo4JPrivateLinkPlugin = createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  extensions: [privateEndpointServiceApi, privateEndpointsPage],
  pluginId: 'neo4j-private-link',
  routes: {
    root: privateEndpointsRouteRef,
  },
});
